import { render, staticRenderFns } from "./BosMessageBanner.vue?vue&type=template&id=ad6218e8"
import script from "./BosMessageBanner.vue?vue&type=script&lang=js"
export * from "./BosMessageBanner.vue?vue&type=script&lang=js"
import style0 from "./BosMessageBanner.vue?vue&type=style&index=0&id=ad6218e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports